import { render, staticRenderFns } from "./ContractDetailsComments.vue?vue&type=template&id=830571d8&scoped=true"
import script from "./ContractDetailsComments.vue?vue&type=script&lang=js"
export * from "./ContractDetailsComments.vue?vue&type=script&lang=js"
import style0 from "./ContractDetailsComments.vue?vue&type=style&index=0&id=830571d8&prod&lang=scss&scoped=true"
import style1 from "./ContractDetailsComments.vue?vue&type=style&index=1&id=830571d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830571d8",
  null
  
)

export default component.exports